import { SyntheticEvent } from 'react';
import { Typography } from '@mui/material';
import { Alert, Link } from '@elementary/common-ui/components';
import useIncidentOverviewSidePanel from 'incidents/hooks/useIncidentOverviewSidePanel';
import { themeTokens } from '@elementary/common-ui/style/tokens';
import useIncidentSummaryById from '../../hooks/useIncidentSummaryById';

type Props = {
  mergedIntoId: string;
};

const MergedIncidentAlert = ({ mergedIntoId }: Props) => {
  const { isLoading, isError, data } = useIncidentSummaryById(mergedIntoId);
  const { onOpen } = useIncidentOverviewSidePanel();

  const primaryTitle = data?.incidentV2?.title;

  const handleOpenPrimary = (e: SyntheticEvent) => {
    e.preventDefault();
    onOpen(mergedIntoId);
  };

  return (
    <Alert severity="info" sx={{ flexShrink: 0 }}>
      {isLoading && (
        <Typography component="p" variant="body2" sx={{ m: 0 }}>
          This incident has been merged into another incident.
        </Typography>
      )}
      {!isLoading && isError && (
        <Typography component="p" variant="body2" sx={{ m: 0 }}>
          This incident was merged into{' '}
          <Link
            href="#"
            onClick={handleOpenPrimary}
            style={{ fontWeight: themeTokens.fontWeight.regular }}
          >
            the primary incident
          </Link>{' '}
          to see the latest details.
        </Typography>
      )}
      {!isLoading && !isError && (
        <Typography component="p" variant="body2" sx={{ m: 0 }}>
          This incident has been merged into{' '}
          {primaryTitle ? (
            <Link
              href="#"
              onClick={handleOpenPrimary}
              style={{ fontWeight: themeTokens.fontWeight.regular }}
            >
              {primaryTitle}
            </Link>
          ) : (
            'another incident'
          )}
        </Typography>
      )}
    </Alert>
  );
};

export default MergedIncidentAlert;
